import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetComplianceInvestigationDetailsAsync,
  IComplianceInvestigationDetails,
} from "../../api/IComplianceInvestigation";
import { RootState } from "../store";

export interface ComplianceInvestigationState {
  fetchStatus: string;
  complianceInvestigation?: IComplianceInvestigationDetails;
}

const initialState: ComplianceInvestigationState = {
  fetchStatus: "Loading...",
  complianceInvestigation: undefined,
};

export const loadComplianceInvestigationAsync = createAsyncThunk(
  "complianceInvestigation/load",
  async (complianceInvestigationId: string) => {
    const response = await GetComplianceInvestigationDetailsAsync(
      complianceInvestigationId
    );
    // The value we return becomes the `fulfilled` action payload
    return response;
  }
);

export const complianceInvestigationSlice = createSlice({
  name: "complianceInvestigation",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadComplianceInvestigationAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(loadComplianceInvestigationAsync.fulfilled, (state, action) => {
        state.fetchStatus = "idle";
        state.complianceInvestigation = action.payload;
      });
  },
});

export const selectComplianceInvestigation = (state: RootState) =>
  state.complianceInvestigation;

export default complianceInvestigationSlice.reducer;
